import { useEffect } from "react";
import type { BryntumTaskBoard } from "@bryntum/taskboard-react-thin";
import { COLUMN_WIDTHS } from "../configure-panel";

export function useDynamicTasksPerRow(
   taskBoardRef: React.RefObject<BryntumTaskBoard>,
   isLoading: boolean,
   isDraggingRef: React.MutableRefObject<boolean>,
   selectedColumnWidth: string,
) {
   useEffect(() => {
      if (isLoading || !taskBoardRef.current?.instance) return;

      const taskboard = taskBoardRef.current.instance;
      const taskboardElement = (taskboard as any).element as HTMLElement | null;
      const columnBody = taskboardElement?.querySelector(
         ".b-task-board-column-body-inner",
      ) as HTMLElement | null;
      if (!columnBody || !taskboardElement) return;
      const columnWidthPx = COLUMN_WIDTHS[selectedColumnWidth];

      const observer = new ResizeObserver((entries) => {
         if (isDraggingRef.current) return;

         for (const entry of entries) {
            const width = entry.contentRect.width;
            const newTasksPerRow = Math.max(1, Math.floor(width / columnWidthPx));
            if ((taskboard as any).tasksPerRow !== newTasksPerRow) {
               (taskboard as any).tasksPerRow = newTasksPerRow;
            }
         }
      });

      const handleExternalDragStart = () => {
         isDraggingRef.current = true;
      };
      const handleExternalDragEnd = () => {
         isDraggingRef.current = false;
      };

      observer.observe(columnBody);
      taskboardElement.addEventListener("dragenter", handleExternalDragStart);
      taskboardElement.addEventListener("drop", handleExternalDragEnd);
      taskboardElement.addEventListener("dragleave", handleExternalDragEnd);

      return () => {
         observer.disconnect();
         taskboardElement.removeEventListener("dragenter", handleExternalDragStart);
         taskboardElement.removeEventListener("drop", handleExternalDragEnd);
         taskboardElement.removeEventListener("dragleave", handleExternalDragEnd);
      };
   }, [taskBoardRef, isLoading, isDraggingRef, selectedColumnWidth]);
}
